export default "__VITE_ASSET__DtJDbK74__";